import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { AuthApi } from "../../api/common/apiIndex";
import { toast } from "react-toastify";
import { IoMdMail, IoMdArrowBack } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import OnSuccess from "../common/commonUtils/OnSuccess"; 
import PublicShell from "../common/shell/PublicShell";
import "./LoginForm.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: ({ email }) => AuthApi.forgotPassword({ email }),
    onSuccess: (msg) => {
      setSuccess(true);
    },
    onError: (err) => {
      const msg = err?.response?.data || "Something went wrong.";
      toast.error(msg);
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email?.trim()) {
      toast.warn("Please enter your email.");
      return;
    }
    mutation.mutate({ email: email.trim() });
  };

  return (
    <PublicShell className="login-light">
      <div className="card shadow-sm border-0 rounded-4 w-100" style={{ maxWidth: 360 }}>
        <div className="card-body p-3 p-sm-4">
          {!success ? (
            <>
              <h1 className="h4 text-center fw-semibold mb-3">Forgot Password</h1>
              <p className="text-muted small text-center mb-4">
                Enter your email address and we’ll send you a password reset link.
              </p>

              <form onSubmit={handleSubmit}>
                <div className="form-floating mb-3">
                  <input
                    id="email"
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    required
                  />
                  <label htmlFor="email">Email</label>
                </div>

                <div className="d-grid gap-2">
                  <button
                    type="submit"
                    className="ui-btn btn-primary btn-modern rounded-pill d-inline-flex align-items-center justify-content-center gap-2 py-2 shadow-sm"
                    disabled={mutation.isPending}
                    aria-busy={mutation.isPending}
                  >
                    {mutation.isPending && (
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                    )}
                    <IoMdMail aria-hidden="true" />
                    <span>Send Reset Link</span>
                  </button>

                  <Link
                    to="/login"
                    className="ui-btn text-decoration-none btn-outline-secondary btn-modern rounded-pill d-inline-flex align-items-center justify-content-center gap-2 py-2"
                    aria-label="Back to login"
                  >
                    <IoMdArrowBack aria-hidden="true" />
                    <span className="text-body">Back to login</span>
                  </Link>
                </div>
              </form>
            </>
          ) : (
            <OnSuccess
              message="Password reset link sent!"
              details="If the email exists, you’ll receive a message with instructions shortly. Click Done to return to login."
              onDone={() => navigate("/login")}
            />
          )}
        </div>
      </div>
    </PublicShell>
  );
}
